import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import * as models from '../../models'; 

export interface IGitEnvVariablesService {
  getGitEnvVariables(): Observable<models.GitEnvVariables>;
}

export const GIT_ENV_VARIABLES_SERVICE_TOKEN = new InjectionToken('Shared.IGitEnvVariablesService');
